import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '../../../../services/data.service';

@Component({
	selector: 'schools-detail-basic-information',
	templateUrl: './basic.html'
})
export class SchoolsDetailBasicInformation {
	@Input() form: FormGroup;
	@Input() action: string;

	public constructor(
		private dataService: DataService
	) {

	}
}


// WEBPACK FOOTER //
// ./src/pages/schools/detail/basic/basic.ts